import { CLIENT_KEY } from '../constants'
import { popinApi } from './api'

const clientInfoUrl = '/account/client_info'

export const accountApi = {
  getClientInfo: function () {
    return popinApi
      .get(`${clientInfoUrl}?client_key=${CLIENT_KEY}`)
      .then((stash) => {
        if (!!stash) {
          return stash.info
        } else {
          return {}
        }
      })
  },
  updateClientInfo: function (key, val) {
    return this.getClientInfo().then((oldStash) => {
      const newInfo = oldStash || {}
      newInfo[key] = val
      const postData = {
        client_key: CLIENT_KEY,
        info: newInfo,
      }
      return popinApi.post(clientInfoUrl, postData)
    })
  },
  switchPlan: function (pricing_plan) {
    return popinApi.post(`/account/subscription/switchPlan`, {
      pricing_plan,
    })
  },
  update: function (account) {
    return popinApi.post('/account/settings', account);
  },
  startTrial: async function (user) {

    if (!user) {
      user = await popinApi.get('/account/settings');
      console.log('User fetched', user);
    }

    fetch(`https://hooks.zapier.com/hooks/catch/2071323/b5t6e3m?email=${user.email}&firstname=${user.first_name}&lastname=${user.last_name}&reason=POPin 14-Day Trial&source=StartTrialModal`)
    .then((res) => {
        console.log("POPin 14-Day Trial Zapier Webhook result", res);
    })
    .catch((err) => {
        console.error("Unable to send request to POPin 14-Day Trial Zapier webhook", err);
    })

    await popinApi.post(`/account/start-trial`, {})
  },
  create: function(account) {
    return popinApi.post(`/account/create`, {
      email: account.email,
      firstName: account.firstName,
      lastName: account.lastName,
      reason: account.why,
      secret: "peeiXG0uCsgB0c8rnXYM",
    });
  },
  verifyInitiate: function(email) {
    return popinApi.post('/authenticate/initiate', {
      email: email,
    });
  }
}
